export class MigrationListItem {
    version = 0;
    name = '';
    isApplied = false;
    isCurrent = false;
    isDirty = false;
}

export class MigrationStatus {
    currentVersion = 0;
    dirty = false;
    totalCount = 0;
    appliedCount = 0;
    pendingCount = 0;
    environment = '';
    migrations: MigrationListItem[] = [];
}

export class MigrationDetail {
    version = 0;
    name = '';
    upSql = '';
    downSql = '';
}

export class MigrationRollbackResult {
    previousVersion = 0;
    newVersion = 0;
    dirty = false;
    success = false;
}
